import { useApi } from './use-api-call';


export const useSearchAccessRoleApi = () => useApi<{ 
accessRoles: AccessRoleDTO[];
        allowEdit: boolean; 
    }>('/access-role/search-access-role');

export const useGetAccessRoleApi = () => useApi<{ accessRole: AccessRoleDTO; allowEdit: boolean; }>('/access-role/get-access-role/{id}');

export const useSaveAccessRoleApi = () => useApi<{ accessRole: AccessRoleDTO}>('/access-role/save-access-role');

export const useDeleteAccessRoleApi = () => useApi('/access-role/delete-access-role/{id}');

export interface AccessRoleDTO { 
id:string;
title:string;
}
